import N2StylesModal from '../components/N2StylesModal'
import CopyFieldToClipboard from '../components/CopyFieldToClipboard'
import AssetUploader from '../components/uploads/AssetUploader'

class AnnotationsAssets {
  constructor(params) {
    this.params = params;
    this.assetUploader = new AssetUploader(this, { showNewImage: true });
  }

  unload() {
    this.assetUploader.unload()
  }

  index() {
    $('.js-secondary-toggle-nav').addClass('hidden')
    if (!this.params.locked){
      this.assetUploader.init();
    }
    if (this.params.type != "Annotation::CsrNote" && this.params.type != "Annotation::PubIssue") {
      N2.handle("click", ".back-arrow", (evt) => {
        if ($(".asset-preview-small").length == 0) {
          evt.preventDefault();
          new N2StylesModal('.js-annotation-empty-modal');
        }
      });
    }
  }

  show() {
    new CopyFieldToClipboard();

    N2.bindHandler('click', '.js-save-caption', (event) =>{
      const url =  `/annotations/${this.params.annotationId}/assets/${this.params.id}/captions`
      let form = new N2Styles.manualForm(url)
      form.addInput('asset[caption]', $('#asset-caption').val())
      form.patch() 
    })

    N2.bindHandler('swipeleft', $('.js-swipe-image').hammer(), (evt) => {
      $('.js-right').click();
    });
    N2.bindHandler('swiperight', $('.js-swipe-image').hammer(), (evt) => {
      $('.js-left').click();
    });
  }

  assetUploadUrl() {
    return `/annotations/${this.params.annotationId}/assets`
  }

  assetUploadImageLabel() {
    return this.params.type == "Annotation::AddPhoto" ? "Photos" : "Files"
}

  toggleNavBars(){
    if ($('.is-checked').length) {
      const pluralPhoto = $('.is-checked').length == 1 ? 'Photo' : 'Photos'
      $('.js-search-1').removeClass('pink accent-2')
      $('.js-search-1').addClass('blue')
      $('.js-secondary-toggle-nav').removeClass('hidden')
      $('.js-photos-selected').text(`${$('.is-checked').length} ${pluralPhoto} Selected`)
    } else {
      $('.js-secondary-toggle-nav').addClass('hidden')
      $('.js-search-1').removeClass('blue')
      $('.js-search-1').addClass('pink accent-2')
    }
  }
}

export default AnnotationsAssets
